<template>
  <img
    :src="mutableSrc"
    :srcset="mutableSrcset"
    class="base-photo"
    :class="`base-photo--${view}`"
    :alt="alt"
    :width="width"
    :height="height"
  />
</template>

<script>
import NoPhoto from "@/assets/shared/no-photo.svg";
// utils
import { Buffer } from "buffer";

export default {
  props: {
    url: {
      type: String,
      default: "",
    },
    view: {
      type: String,
      default: "fluid",
    },
    width: {
      type: [String, Number],
      default: "0",
    },
    height: {
      type: [String, Number],
      default: "0",
    },
    gravity: {
      type: String,
      default: "sm",
    },
    enlarge: {
      type: String,
      default: "no",
    },
    resizingType: {
      type: String,
      default: "auto",
    },
    alt: {
      type: String,
      default: "",
    },
  },
  computed: {
    urlBase64() {
      if (!this.url) return null;
      const buff = Buffer.from(encodeURI(this.url));
      return buff.toString("base64");
    },
    numericWidth() {
      return this.toSize(this.width);
    },
    numericHeight() {
      return this.toSize(this.height);
    },
    mutableSrc() {
      if (!this.url) return NoPhoto;
      return this.buildUrl(this.numericWidth || 0, this.numericHeight || 0);
    },
    mutableSrcset() {
      // без валидных размеров удвоенный вариант дал бы rs:auto:NaN:NaN — imgproxy отвечает 404
      if (!this.url || !this.numericWidth || !this.numericHeight) return null;

      return `${this.buildUrl(
        this.numericWidth * 2,
        this.numericHeight * 2
      )} 2x`;
    },
  },
  methods: {
    buildUrl(width, height) {
      return `${process.env.VUE_APP_IMAGE_URL}/rs:${this.resizingType}:${width}:${height}:1/g:sm/${this.urlBase64}`;
    },
    toSize(value) {
      const size = parseInt(value, 10);
      return Number.isFinite(size) && size > 0 ? size : null;
    },
  },
};
</script>

<style lang="scss" scoped>
.base-photo {
  &--fluid {
    @include img-fluid;
  }
}
</style>
